import { twMerge } from "tailwind-merge";
import { NoAccessVariant } from "../../session/controls";
import { deviceIsMobile, isSafari as isBrowserSafari } from "../../utils";
import { BlockedPermissionDescription } from "../BlockedPermissionDescription";

type WithPassThroughProps<P = unknown> = P & {
  className?: string;
  noAccessVariant?: NoAccessVariant;
};

export function BlockedPermissionMessage({
  className,
  isMobile,
  isSafari,
  noAccessVariant,
}: WithPassThroughProps<{
  isMobile: boolean;
  isSafari: boolean;
}>) {
  return (
    <div
      className={twMerge(
        "flex flex-col gap-6 w-full rounded border border-neutral-700 bg-neutral-200 p-4",
        className,
      )}
    >
      <BlockedPermissionDescription
        isMobile={isMobile}
        isSafari={isSafari}
        noAccessVariant={noAccessVariant}
      />
    </div>
  );
}

/**
 * When using this component, make sure any of the following hooks are executed
 * to be sure the application stays in-sync with the user's device permissions:
 * - useUpdateAvailableDevicesInterval
 * - useListenForAvailableDeviceChanges
 */
export function BlockedPermissionMessageWrapper(props: WithPassThroughProps) {
  const isMobile = deviceIsMobile();
  const isSafari = isBrowserSafari();
  return (
    <BlockedPermissionMessage
      {...props}
      isMobile={isMobile}
      isSafari={isSafari}
    />
  );
}
